import { Button, Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import { FinanceDialog } from "web_myplann/Dashboard/Components/FinanceDialog";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type Props = {
	open: boolean;
	onClose: () => void;
};

export const CalculatorLeadErrorDialog: FC<Props> = ({ open, onClose }) => {
	const theme = useTheme();
	const { t } = useResource();

	return (
		<FinanceDialog open={open} onClose={onClose}>
			<Stack
				p={theme.spacingTokens.xl}
				gap={theme.spacingTokens.xl}
				textAlign="center"
				role="alertdialog"
			>
				<Stack gap={theme.spacingTokens.sm}>
					<Typography variant="h3">
						{t(Resources.Calculators.Result.LeadErrorTitle)}
					</Typography>
					<Typography variant="body2">
						{t(Resources.Calculators.Result.LeadErrorText)}
					</Typography>
				</Stack>
				<Button variant="primary" onClick={onClose}>
					{t(Resources.Calculators.Result.LeadErrorButton)}
				</Button>
			</Stack>
		</FinanceDialog>
	);
};
